import { httpV2 } from "@/api";

/**
 * @summary Obtém um conjunto de sinais relacionados ao rolamento de um diagnóstico
 * @param {number} bearingId - Id do rolamento.
 * @returns {promise} Conjunto de sinais.
 */
const GetBearingSignals = async function(bearingId)
{
	return httpV2.get(`/RollingBearingFailuresBearing/${bearingId}/Signals`);
};

export default { GetBearingSignals };